// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".aspect-thumbnail[data-v-1e30df67]{position:relative;display:block;padding-top:67.79661%}.aspect-thumbnail-responsive[data-v-1e30df67]{position:relative;display:block;padding-top:108.10811%}@media (min-width: 768px){.aspect-thumbnail-responsive[data-v-1e30df67]{padding-top:67.79661%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
